import { all, call, takeLatest, put } from "redux-saga/effects";
import { fromQuery } from "utils/query";
import { getQueryFilterName } from "utils/filter";
import {
  keywordTriggeredBannerError,
  keywordTriggeredBannerRequested,
  keywordTriggeredBannerSuccess,
} from "actions";
import { APP_INITIALIZE, QUERY_CHANGE } from "actions/const";
import { fetchBanner } from "services/search/keywordTriggeredBanner";

function parseQueryParameter(searchUrl) {
  const filters = fromQuery(searchUrl);

  return filters[getQueryFilterName()] || "";
}

export function* fetchKeywordTriggeredBanner(action) {
  const searchTerm =
    action.type === APP_INITIALIZE
      ? parseQueryParameter(action.urlSearch)
      : action.value;

  if (!searchTerm) {
    return;
  }

  yield put(keywordTriggeredBannerRequested());

  try {
    const banner = yield call(fetchBanner, searchTerm);

    yield put(keywordTriggeredBannerSuccess(banner));
  } catch {
    yield put(keywordTriggeredBannerError());
  }
}

// watcher
export function* watchKeywordTriggeredBanner() {
  yield all([
    yield takeLatest(QUERY_CHANGE, fetchKeywordTriggeredBanner),
    yield takeLatest(APP_INITIALIZE, fetchKeywordTriggeredBanner),
  ]);
}
